import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';

import { LABEL_SCALE, convictionLabel } from '../../utils/convictionLabel';

// The five conviction labels. Was SCALE / HOLD / TRIM: buy/sell words the
// softened labels replaced everywhere else.
const BAND_COLORS = Object.fromEntries(LABEL_SCALE.map((b) => [b.label, b.color]));

export default function StyleDonut({ scores }) {
  if (!scores?.length) return null;

  const bandData = {};
  scores.forEach(s => {
    const conv = s.combined_conviction || 0;
    const band = convictionLabel(conv);

    if (!bandData[band]) bandData[band] = { count: 0, value: 0 };
    bandData[band].count += 1;
    bandData[band].value += s.position_value || 0;
  });

  const data = Object.entries(bandData)
    .map(([name, { count, value }]) => ({ name, value: Math.round(value), count }))
    .filter(d => d.value > 0);

  if (data.length === 0) return null;

  const total = data.reduce((s, d) => s + d.value, 0);

  const renderLabel = ({ name, percent, cx, cy, midAngle, outerRadius }) => {
    if (percent < 0.08) return null;
    const RADIAN = Math.PI / 180;
    const radius = outerRadius + 20;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);
    return (
      <text x={x} y={y} fill="#94A3B8" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central" fontSize={10}>
        {name}
      </text>
    );
  };

  return (
    <div style={{ width: '100%', maxWidth: 420 }}>
      <h4 style={{ textAlign: 'center', color: '#94A3B8', fontSize: '0.85rem', margin: '0 0 8px' }}>Conviction Distribution</h4>
      <ResponsiveContainer width="100%" height={260}>
        <PieChart>
          <Pie data={data} cx="50%" cy="50%" innerRadius={45} outerRadius={80} dataKey="value" label={renderLabel} labelLine={false}>
            {data.map((entry) => <Cell key={entry.name} fill={BAND_COLORS[entry.name] || '#666'} />)}
          </Pie>
          <Tooltip
            formatter={(value, name, props) => [`$${value.toLocaleString()} (${props.payload.count} positions)`, name]}
            contentStyle={{ background: '#1A1F2E', border: '1px solid #334155', borderRadius: 8, color: '#F1F5F9' }}
            itemStyle={{ color: '#F1F5F9' }}
            labelStyle={{ color: '#94A3B8' }}
          />
        </PieChart>
      </ResponsiveContainer>
      <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '0.35rem 0.75rem', marginTop: '0.25rem' }}>
        {data.map((d) => (
          <span key={d.name} style={{ fontSize: '0.65rem', color: '#94A3B8', display: 'flex', alignItems: 'center', gap: '0.25rem' }}>
            <span style={{ width: 8, height: 8, borderRadius: 2, background: BAND_COLORS[d.name] || '#666', display: 'inline-block' }} />
            {d.name} ({d.count}) {(d.value / total * 100).toFixed(0)}%
          </span>
        ))}
      </div>
    </div>
  );
}
